import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Marquee from "@/components/Marquee";
import CtaBand from "@/components/CtaBand";

export default function HomePage() {
  return (
    <main data-testid="page-home">
      <Hero />
      <TrustStrip />
      <Marquee />
      <CtaBand />
    </main>
  );
}
